module.exports = __webpack_public_path__ + "img/end-parcours.8683752c.png";